var map = {
	"./Profile2.2.jpg": 9651,
	"./ai_chat_project/img1.png": 1354,
	"./ai_chat_project/img2.png": 1937,
	"./ai_chat_project/img3.png": 808,
	"./ai_chat_project/img4.png": 9799,
	"./ai_chat_project/img5.png": 4222,
	"./ai_chat_project/video1.mp4": 6511,
	"./ai_chat_project/video2.mp4": 3656,
	"./animated_image_generator/img1.png": 8730,
	"./animated_image_generator/img2.png": 7713,
	"./animated_image_generator/img3.png": 8648,
	"./animated_image_generator/img4.png": 8263,
	"./calendar_gpt_project/video1.mp4": 3062,
	"./calendar_gpt_project/video2.mp4": 3033,
	"./calendar_gpt_project/video3.mp4": 5380,
	"./calendar_gpt_project/video4.mp4": 7799,
	"./donut_modeling_project/img1.png": 2799,
	"./donut_modeling_project/img2.png": 340,
	"./donut_modeling_project/video1.mp4": 5400,
	"./donut_modeling_project/video2.mp4": 9199,
	"./donut_modeling_project/video3.mp4": 602,
	"./goose_glance_extension/img1.png": 6757,
	"./goose_glance_extension/img2.png": 5278,
	"./goose_glance_extension/img3.png": 8423,
	"./goose_glance_extension/img4.png": 2632,
	"./llm_web_app_deployment_project/img1.jpeg": 4722,
	"./llm_web_app_deployment_project/img2.png": 7670,
	"./llm_web_app_deployment_project/img3.png": 3999,
	"./photography/img1.jpg": 6494,
	"./photography/img2.jpg": 6553,
	"./photography/img3.jpg": 4828,
	"./photography/img4.jpg": 9175,
	"./photography/img5.jpg": 4714
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2169;